import type { SxProps, Theme } from '@mui/material/styles';

export const multiPrimaryAutocompleteFieldStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1.5
	} satisfies SxProps<Theme>,

	fieldContainer: {
		display: 'grid',
		gridTemplateColumns: { xs: '1fr auto', sm: '1fr auto' },
		alignItems: { xs: 'center', sm: 'start' },
		rowGap: 0.75
	} satisfies SxProps<Theme>,

	listError: {
		color: 'error.main',
		fontSize: '0.75rem'
	} satisfies SxProps<Theme>
};
